import {BaseEntityUnDeletable} from '../../../common/entities';

export class Level extends BaseEntityUnDeletable {
    description: string;
    isActive: boolean;
}
